import { FaChalkboardTeacher, FaSeedling } from "react-icons/fa";
import { BiSupport } from "react-icons/bi";
import { MdOutlineHandshake } from "react-icons/md";

export const countryCodesList = [
  { code: "+1", name: "United States", flag: "🇺🇸" },
  { code: "+1", name: "Canada", flag: "🇨🇦" },
  { code: "+44", name: "United Kingdom", flag: "🇬🇧" },
  { code: "+33", name: "France", flag: "🇫🇷" },
  { code: "+39", name: "Italy", flag: "🇮🇹" },
  { code: "+49", name: "Germany", flag: "🇩🇪" },
  { code: "+34", name: "Spain", flag: "🇪🇸" },
];

export const states = [
  "AL",
  "AK",
  "AZ",
  "AR",
  "CA",
  "CO",
  "CT",
  "DE",
  "FL",
  "GA",
  "HI",
  "ID",
  "IL",
  "IN",
  "IA",
  "KS",
  "KY",
  "LA",
  "ME",
  "MD",
  "MA",
  "MI",
  "MN",
  "MS",
  "MO",
  "MT",
  "NE",
  "NV",
  "NH",
  "NJ",
  "NM",
  "NY",
  "NC",
  "ND",
  "OH",
  "OK",
  "OR",
  "PA",
  "RI",
  "SC",
  "SD",
  "TN",
  "TX",
  "UT",
  "VT",
  "VA",
  "WA",
  "WV",
  "WI",
  "WY",
];

export const about_approach_data = [
  {
    id: 1,
    title: "Educate",
    text: "We're committed to advancing wound care education by providing accessible resources, training, and support that empower clinicians to deliver better care and improve patient outcomes.",
    icon: <FaChalkboardTeacher />
  },
  {
    id: 2,
    title: "Growth",
    text: "We're dedicated to driving growth in the wound care community by expanding access to innovative products, education, and partnerships that improve outcomes and elevate patient care.",
    icon: <FaSeedling />
  },
  {
    id: 3,
    title: "Clawback Insurance",
    text: "We’ve partnered with a clawback insurance provider to protect healthcare partners while advancing access to quality wound care and education in underserved communities nationwide.",
    icon: <MdOutlineHandshake />
  },
];

export const about_team = [
  { 
    id: 1,
    name: 'Dr. Eric Vasquez',
    title: 'CEO',
    image: 'https://plus.unsplash.com/premium_photo-1661293876679-5cee3ee9e8c8?q=80&w=2340&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    bio: 'Cognitive computing pioneer with a PhD in Computational Neuroscience from Stanford.',
    email: "jane@promed.com",
    phone: "+1 (555) 123-4567" 

  },
  { 
    id: 2,
    name: 'Rachel Patel',
    title: 'Chief Technology Officer',
    image: 'https://images.unsplash.com/photo-1573497019940-1c28c88b4f3e?q=80&w=1287&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    bio: 'Cognitive computing pioneer with a PhD in Computational Neuroscience from Stanford.',
    email: "jane@promed.com",
    phone: "+1 (555) 123-4567" 

  },
  { 
    id: 3,
    name: 'Dr. Kristen Nkosi',
    title: 'Chief Ethics Officer',
    image: 'https://images.unsplash.com/photo-1581065178047-8ee15951ede6?q=80&w=1315&auto=format&fit=crop&ixlib=rb-4.1.0&ixid=M3wxMjA3fDB8MHxwaG90by1wYWdlfHx8fGVufDB8fHx8fA%3D%3D',
    bio: 'Author of "The Moral Algorithm" and AI policy advisor to the EU Parliament.',
    email: "jane@promed.com",
    phone: "+1 (555) 123-4567" 
  },
]

export const products = [
  {
    id: 1,
    name: 'a;ljfal;kj',
    image: ';laskjdff;',
    disciption: ';ladj',
    link: 'a;dmf'
  },
 
]


